import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

// firebase init - add your own config here
var firebaseConfig = {
    apiKey: "AIzaSyCEdwJcyrXP9q-flgl44VEHrovgtwyCmAI",
    authDomain: "errandite.firebaseapp.com",
    databaseURL: "https://errandite.firebaseio.com",
    projectId: "errandite",
    storageBucket: "errandite.appspot.com",
    messagingSenderId: "781257310365",
    appId: "1:781257310365:web:b207e70b2fc909deb35474"
};
firebase.initializeApp(firebaseConfig)

//var googleAuth = new firebase.auth.GoogleAuthProvider();

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const persistence = firebase.auth.Auth.Persistence.LOCAL

// collection references
const usersCollection = db.collection('users')
const tasksCollection = db.collection('tasks')

// export utils/refs
export {
  db,
  auth,
  //googleAuth,
  usersCollection,
  tasksCollection,
  persistence
}